
import  store from '@/common/store/index.js'
import api from '@/common/api-util.js'
import log from '@/common/log.js'

function getLocalToken(){
    let token = localStorage.getItem('token');
    store.commit("setToken", token);
    return token;
}

function getLocalUser(){
    let user = localStorage.getItem('user');
    store.commit("setUser", JSON.parse(user));
    return user;
}

function getStoreToken(){
    return store.state.token;
}

function getStoreUser(){
    return store.state.user;
}

function loginCallback(data){
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    store.commit("setToken", data.token);
    store.commit("setUser", data.user);

}

function userExit() {
    console.log("auth userExit")
    localStorage.setItem('token', '');
    localStorage.setItem('user', null);
    store.commit("setToken", '');
    store.commit("setUser", null);
    store.commit("setUserInfoNum", null);

}

function tokenLogin(token) {

}

function isLogin() {
    console.log("isLogin")
    if (store.state.token && store.state.user) {
        return true;
    }
    console.log("isLogin fasle")
    return false;
}

function updateUserInfoNum(callback) {
    api.user.userInfoNum().then(res => {
        if (res.code == api.errorCode.ERROR_USER_NO_LOGIN){
            userExit();
        }
        if (res.code == api.SUCCESS) {
            callback(res.data);
        }
    })
}

function getStoreUserInfoNum() {
    if (store.state.userInfoNum) {
        return store.state.userInfoNum;
    }
    return null;
}

function getUserBasicInfo(callback=null) {
    api.user.userBasicInfo().then(res => {
        if (res.code == api.errorCode.ERROR_USER_NO_LOGIN){
            userExit();
        }
        if (res.code == api.SUCCESS) {
            localStorage.setItem('user', JSON.stringify(res.data));
            store.commit("setUser", res.data);
            if (callback) {
                callback(res.data)
            }
        }
    })
}


export default {
    getLocalToken,
    getLocalUser,
    getUserBasicInfo,
    getStoreToken,
    getStoreUser,
    loginCallback,
    tokenLogin,
    userExit,
    isLogin,
    updateUserInfoNum,
    getStoreUserInfoNum,
}

